export default "__VITE_ASSET__DGm0DBS8__"